import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useStore } from "../zustand/store";
import { Tab, Tabs } from 'react-bootstrap';
import { hitApi, setMyState, getNameInitials, commonToast, assetsUrlPath } from './commonAction';
import svg from './svg';
import {  useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import ConfirmationPopup from './common/ConfirmationPopup';
import ImageCropperModal from './common/ImageCropperModal';
import { UserRound, KeyRound, ShieldCheck, Eye, EyeOff } from 'lucide-react';

function Profile() {
    const navigate = useNavigate();
    let store = useStore(state => state),
        { token, role, email, name, profilePic, isVerified } = store.userData;
    let [state, setState] = useState({
        name: name,
        password: '',
        newPassword: '',
        conPassword: '',
        otpValue: '',
        profile: '',
        iconUrl: ''
    });
    const [btnLoading,       setBtnLoading]       = useState(false);
    const [isDragging,       setIsDragging]       = useState(false);
    const [showNewPassword,  setShowNewPassword]  = useState(false);
    const [showConPassword,  setShowConPassword]  = useState(false);
    const [cropperOpen,  setCropperOpen]  = useState(false);
    const [rawImageSrc,  setRawImageSrc]  = useState(null);
    const fileInputRef = useRef(null);

    const handleFilePick = useCallback((file) => {
        if (!file) return;
        const valid = ['image/jpg', 'image/jpeg', 'image/png'].includes(file.type);
        if (!valid) { commonToast('error', 'Profile pictures must be JPG, PNG, or JPEG.'); return; }
        if (file.size > 5 * 1024 * 1024) { commonToast('error', 'Image must be under 5 MB.'); return; }
        setRawImageSrc(URL.createObjectURL(file));
        setCropperOpen(true);
        if (fileInputRef.current) fileInputRef.current.value = '';
    }, []);

    const handleCropDone = useCallback((blob) => {
        const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' });
        setMyState(setState, { profile: file, iconUrl: URL.createObjectURL(blob) });
        setCropperOpen(false);
        setRawImageSrc(src => { if (src) URL.revokeObjectURL(src); return null; });
    }, []);

    const handleCropCancel = useCallback(() => {
        setCropperOpen(false);
        setRawImageSrc(src => { if (src) URL.revokeObjectURL(src); return null; });
    }, []);

    const onDrop = useCallback((e) => {
        e.preventDefault();
        setIsDragging(false);
        handleFilePick(e.dataTransfer.files[0]);
    }, [handleFilePick]);

    const onDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
    const onDragLeave = () => setIsDragging(false);

    const url = window.location.href;


    const [activeTab, setActiveTab] = useState(url.endsWith('#verification') ? 'contact' : 'home'); // State to track the active tab
    const nameInputRef = useRef(null); // Create a ref for the name input field
    const passwordInputRef = useRef(null); // Create a ref for the password input field

    useEffect(() => {
        if (activeTab === 'home' && nameInputRef.current) {
            nameInputRef.current.focus();
        } else if (activeTab === 'profile' && passwordInputRef.current) {
            passwordInputRef.current.focus();
        }
    }, [activeTab]);

    const handleChangePassword = (e) => {
        e.preventDefault();
        if (state.conPassword && state.newPassword) {

            if (state.newPassword.length < 6) {
                commonToast('error', 'Password must be at least 6 characters long and contain no spaces.')
                return
            }
            if (/\s/.test(state.newPassword)) {
                commonToast('error', 'Password must be at least 6 characters long and contain no spaces.')
                return
            }
            if (state.conPassword != state.newPassword) {
                commonToast('error', 'New password and confirm password should be same.')
                return;
            }
            setBtnLoading(true)
            hitApi({
                url: 'accounts/change-password',
                method: "PATCH",
                data: {
                    // "currentPassword": state.password,
                    "newPassword": state.newPassword,
                    "confirmPassword": state.conPassword
                }
            }, (resp, err = null) => {
                setBtnLoading(false);
                if (resp.status) {
                    setMyState(setState, {
                        newPassword: '',
                        conPassword: ''
                    });
                }
            });
        } else {
            commonToast('error', 'Fields can not be empty.')
        }
    }


    const verifyAccount = (e) => {
        e.preventDefault();
        if (state.otpValue) {
            setBtnLoading(true);
            hitApi({
                url: 'accounts/account-verification',
                method: "PATCH",
                data: { token: state.otpValue }
            }, (resp, err = null) => {
                setBtnLoading(false)
                if (resp.status) {
                    let newdata = { ...store.userData, isVerified: true };
                    store.updateStore("userData", newdata);
                    setMyState(setState, {
                        otpValue: '',
                    });
                }
            });
        } else {
            commonToast('error', 'Verification Code is required.')
        }

    }

    const resendOTP = () => {
        setBtnLoading(true)
        hitApi({
            url: 'accounts/re-send-verification',
            method: "GET",
            data: { token: token }
        }, (resp, err = null) => { setBtnLoading(false) });
    }

    const updateProfile = (e) => {
        e.preventDefault();

        let isValid = state.profile ? (state.profile.type == 'image/jpg' || state.profile.type == 'image/jpeg' || state.profile.type == 'image/png') : true;

        if(state.name.length==0)
        {
            commonToast('error', `Name is required `);
            return
        }
        if (isValid) {

            const formData = new FormData();
            if (state.profile) {
                formData.append('profile', state.profile);
            }

            formData.append('name', state.name);
            setBtnLoading(true);

            hitApi({
                url: 'accounts/update-profile',
                method: "PATCH",
                isFormData: true,
                data: formData
            }, (resp, err) => {
                setBtnLoading(false)
                if (resp.status) {
                    let newdata;
                    if (state.profile) {
                        newdata = { ...store.userData, name: state.name, profilePic: resp?.data?.profilePic };
                    } else {
                        newdata = { ...store.userData, name: state.name };
                    }
                    store.updateStore("userData", newdata);
                }
                else {

                    commonToast('error', { err });

                }
            });
        } else {

            commonToast('error', `Profile pictures must be JPG, PNG, or JPEG files.`);
        }



    }

    // const updateProfile = (e) => {
    //     e.preventDefault();

    //     let isValid = state.profile ? (state.profile.type == 'image/jpg' || state.profile.type == 'image/jpeg' || state.profile.type == 'image/png') : true;


    //     if (isValid) {

    //         const formData = new FormData();
    //         if (state.profile) {
    //             formData.append('profile', state.profile);
    //         }

    //         formData.append('name', state.name);
    //         setBtnLoading(true);

    //         hitApi({
    //             url: 'accounts/update-profile',
    //             method: "PATCH",
    //             isFormData: true,
    //             data: formData
    //         }, (resp, err) => {
    //             setBtnLoading(false)
    //             if (resp.status) {
    //                 let newdata;
    //                 if (state.profile) {
    //                     newdata = { ...store.userData, name: state.name, profilePic: resp?.data?.profilePic };
    //                 } else {
    //                     newdata = { ...store.userData, name: state.name };
    //                 }
    //                 store.updateStore("userData", newdata);
    //             }
    //             else {
    //                 commonToast('error', { err });

    //             }
    //         });
    //     } else {

    //         commonToast('error', `Profile pictures must be JPG, PNG, or JPEG files.`);
    //     }



    // }

    const deleteAccount = (e) => {
        // e.preventDefault();
            hitApi({
                url: 'accounts/delete-account',
                method: "DELETE",
                data: {}
            }, (resp, err) => {
                if (resp.status) {
                    store.updateStore("userData", {});
                    Cookies.remove('authToken');
                    navigate('/');
                }
            });




    }
    const avatarPreview = state.iconUrl || (profilePic ? assetsUrlPath(profilePic) : null);

    return (
        <>
            <div className="pxl-rb-header-wrap">
                <div className="pxl-headingTop">
                    <h2 className="pxl-rb-header-heading">Account Settings</h2>
                </div>
                <div className="pxl-rb-header-right">
                    <div className="pxl-header-toogle-btn" onClick={() => store.updateStore("resMenuToggle", !store.resMenuToggle)}>
                        <svg className="pxl-header-toogle-svg" viewBox="0 0 100 100" width="80">
                            <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-top" d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
                            <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-middle" d="m 30,50 h 40" />
                            <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-bottom" d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className="pxl-settings-page">
                {/* Left: profile card */}
                <aside className="pxl-settings-aside">
                    <div className="pxl-profile-card">
                        <div className="pxl-profile-card-avatar">
                            {avatarPreview
                                ? <img src={avatarPreview} alt="Profile" />
                                : <span>{getNameInitials(name)}</span>}
                            {!isVerified && (
                                <span className="pxl-profile-card-unverified" title="Account not verified">!</span>
                            )}
                        </div>
                        <div className="pxl-profile-card-info">
                            <h3>{name}</h3>
                            <p>{email}</p>
                            {isVerified
                                ? <span className="pxl-profile-card-badge pxl-badge-verified">{svg.app.verifyIcon} Verified</span>
                                : <span className="pxl-profile-card-badge pxl-badge-unverified">Not verified</span>}
                        </div>
                    </div>

                    <nav className="pxl-settings-nav">
                        {[
                            { key: "home",    label: "Profile Settings",  icon: <UserRound    size={18} strokeWidth={1.8} /> },
                            { key: "profile", label: "Password Settings", icon: <KeyRound     size={18} strokeWidth={1.8} /> },
                            /* { key: "contact", label: "Verify Account",    icon: <ShieldCheck  size={18} strokeWidth={1.8} /> }, */
                        ].map(tab => (
                            <button
                                key={tab.key}
                                className={"pxl-settings-nav-item" + (activeTab === tab.key ? " active" : "")}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.icon}
                                {tab.label}
                            </button>
                        ))}
                    </nav>
                </aside>

                {/* Right: tab content */}
                <div className="pxl-settings-content">

                    {/* Profile Settings */}
                    {activeTab === 'home' && (
                        <div className="pxl-settings-panel">
                            <div className="pxl-settings-panel-header">
                                <h3>Profile Settings</h3>
                                <p>Update your name and profile picture</p>
                            </div>
                            <form onSubmit={updateProfile}>
                                <div className="cun-account-settingFlex">
                                    <div className="pxl_input_feilds">
                                        <label>Full Name <span className="pxl-star-red">*</span></label>
                                        <input ref={nameInputRef} type="text" value={state.name} placeholder="Enter your full name"
                                            onChange={(e) => setMyState(setState, { name: e.target.value })} />
                                    </div>
                                    <div className="pxl_input_feilds">
                                        <label>Email Address <span className="pxl-star-red">*</span></label>
                                        <input className="pxlInputDisableField" readOnly type="email" value={email} placeholder="Email address" />
                                    </div>
                                </div>

                                <div className="pxl_input_feilds">
                                    <label>Profile Picture</label>
                                    <div
                                        className={"pxl-dropzone" + (isDragging ? " pxl-dropzone--drag" : "")}
                                        onDragOver={onDragOver}
                                        onDragLeave={onDragLeave}
                                        onDrop={onDrop}
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        {avatarPreview ? (
                                            <div className="pxl-dropzone-has-preview">
                                                <div className="pxl-dropzone-avatar">
                                                    <img src={avatarPreview} alt="Preview" />
                                                    <button
                                                        type="button"
                                                        className="pxl-dropzone-change-btn"
                                                        onClick={(e) => { e.stopPropagation(); fileInputRef.current?.click(); }}
                                                    >
                                                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="pxl-dropzone-has-preview-text">
                                                    <p className="pxl-dropzone-label">Photo selected</p>
                                                    <p className="pxl-dropzone-hint">Click to choose a different photo</p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="pxl-dropzone-empty">
                                                <div className="pxl-dropzone-icon">
                                                    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                                                    </svg>
                                                </div>
                                                <p className="pxl-dropzone-label"><strong>Click to upload</strong> or drag &amp; drop</p>
                                                <p className="pxl-dropzone-hint">JPG, PNG or JPEG &mdash; max 5 MB</p>
                                            </div>
                                        )}
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/jpg,image/jpeg,image/png"
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFilePick(e.target.files[0])}
                                        />
                                    </div>
                                </div>

                                <div className="pxl_profile_field_wrap">
                                    <button type="submit" className="pxlCommon-btn" disabled={btnLoading}>
                                        {btnLoading ? 'Saving…' : 'Save Changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Password Settings */}
                    {activeTab === 'profile' && (
                        <div className="pxl-settings-panel">
                            <div className="pxl-settings-panel-header">
                                <h3>Password Settings</h3>
                                <p>Choose a strong password to keep your account secure</p>
                            </div>
                            <form onSubmit={handleChangePassword}>
                                <div className="pxl_input_feilds">
                                    <label>New Password <span className="pxl-star-red">*</span></label>
                                    <div className="pxl-pw-field">
                                        <input ref={passwordInputRef} type={showNewPassword ? 'text' : 'password'} value={state.newPassword} placeholder="Enter new password"
                                            onChange={(e) => setMyState(setState, { newPassword: e.target.value })} />
                                        <button type="button" className="pxl-pw-toggle" tabIndex={-1}
                                            onClick={() => setShowNewPassword(v => !v)}>
                                            {showNewPassword ? <EyeOff size={17} strokeWidth={1.8} /> : <Eye size={17} strokeWidth={1.8} />}
                                        </button>
                                    </div>
                                </div>
                                <div className="pxl_input_feilds">
                                    <label>Confirm Password <span className="pxl-star-red">*</span></label>
                                    <div className="pxl-pw-field">
                                        <input type={showConPassword ? 'text' : 'password'} value={state.conPassword} placeholder="Confirm new password"
                                            onChange={(e) => setMyState(setState, { conPassword: e.target.value })} />
                                        <button type="button" className="pxl-pw-toggle" tabIndex={-1}
                                            onClick={() => setShowConPassword(v => !v)}>
                                            {showConPassword ? <EyeOff size={17} strokeWidth={1.8} /> : <Eye size={17} strokeWidth={1.8} />}
                                        </button>
                                    </div>
                                </div>
                                <div className="pxl_profile_field_wrap">
                                    <button type="submit" className="pxlCommon-btn" disabled={btnLoading}>
                                        {btnLoading ? 'Saving…' : 'Update Password'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Verify Account */}
                    {activeTab === 'contact' && (
                        <div className="pxl-settings-panel">
                            <div className="pxl-settings-panel-header">
                                <h3>Verify Account</h3>
                                <p>Confirm your email to unlock full access</p>
                            </div>
                            {!isVerified ? (
                                <form onSubmit={verifyAccount}>
                                    <div className="pxl-verify-info-box">
                                        <p>We emailed a 6-digit code to <strong>{email}</strong>. Enter it below to verify your account.</p>
                                    </div>
                                    <div className="pxl_input_feilds pxl_input_sm">
                                        <label>Verification Code <span className="pxl-star-red">*</span></label>
                                        <input type="text" value={state.otpValue} placeholder="Enter 6-digit code"
                                            onChange={(e) => setMyState(setState, { otpValue: e.target.value })} />
                                    </div>
                                    <div className="pxl_profile_field_wrap">
                                        <button type="submit" className="pxlCommon-btn" disabled={btnLoading}>
                                            {btnLoading ? 'Verifying…' : 'Verify Account'}
                                        </button>
                                    </div>
                                    <div className="pxl_input_note pxlresendText">
                                        <p>Didn't receive a code? <a onClick={resendOTP} style={{cursor:'pointer'}}>Resend Code</a></p>
                                    </div>
                                </form>
                            ) : (
                                <div className="pxl-verified-state">
                                    <span className="pxl-verified-icon">{svg.app.verifyIcon}</span>
                                    <h4>Your account is verified</h4>
                                    <p>Your email address has been confirmed successfully.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <ImageCropperModal
                show={cropperOpen}
                imageSrc={rawImageSrc}
                onCrop={handleCropDone}
                onCancel={handleCropCancel}
            />

            <ConfirmationPopup
                shownPopup={state.removeMe}
                closePopup={() => {
                    setMyState(setState, {
                        removeMe: false,
                    })
                }}
                type={"design"}
                title={`Do you want to Delete Your Account ?`}
                subTitle={'This action cannot be undone.'}
                yesBtn={"Yes"}
                btnLoader={state.isDataload}
                removeAction={() => {
                deleteAccount()
                }}
            />
        </>
    )
}

export default Profile
